import { produce } from 'immer'
import { AnyAction } from '@reduxjs/toolkit'
import {
  CREATE_LEAD_REFERENCE_FAILED,
  CREATE_LEAD_REFERENCE_SUCCESS,
  CREATE_PROSTHESIS_SUCCESS,
  GET_GAMME_RANGE_SUCCESS,
  GET_LEAD_REFERENCE_CONNEXIONS_SUCCESS,
  GET_LEADS_REFERENCES_SUCCESS,
  GET_LEADS_REFERENCES_SUMMARY_SUCCESS,
  GET_PROSTHESIS_REFERENCES_SUCCESS,
  GET_PROSTHESIS_REFERENCES_SUMMARY_SUCCESS,
  GET_TRANSMITTER_REFERENCE_SUCCESS,
  GET_TRANSMITTER_REFERENCE_SUMMARY_SUCCESS,
} from '../constants'

interface IState {
  prosthesisReferencesCount: number| null,
  prosthesisReferences: IProsthesisReference[],
  leadReferenceCount: number | null,
  leadsReferences: ILeadReference[],
  transmitterReferenceCount: number | null,
  transmitterReferences: ITransmitterReference[],
  leadConnexions: ILeadConnection[],
}

export interface ILeadConnection {
  id: number
  created_at: string
  updated_at: string | null
  deleted_at: string | null
  lead_type: 'STIM' | 'DEF'
  lead_connection: 'IS1' | 'IS4' | 'DF1' | 'DF4' | 'UNDER_SKIN'
}

export interface IResponseStatus {
  message: string
  error: string
  data: any
  status: number
}

export interface ICreateProsthesis {
  model: string
  reference: string
  makerId: number
  gammeId: number
  rangeId: number
  facturation?: number
}

export interface IBillable {
  createdAt: string
  deletedAt: string | null
  amount: number
  applicableDate: string
  id: number
  modifiedAt: string | null
  prosthesisReferenceId: number
}

export interface IProsthesisReference {
  billableList: IBillable[]
  createdAt: string
  deletedAt: string | null
  gammeId: number
  id: number
  maker: {}
  modifiedAt: string | null
  prosthesisGamme: {}
  prosthesisMakerId: number
  prosthesisModel: string
  prosthesisRange: {}
  rangeId: number
  referenceName: string
}

export interface ITransmitterReference {
  id: number
  createdAt: string
  updatedAt: string | null
  deletedAt: string | null
  reference_name: string
  transmitter_model: string
  company: {}
}

export interface ILeadReference {
  id: number
  createdAt: string
  updatedAt: string | null
  deletedAt: string | null
  reference: string
  description: string| null
  length: number
  company: {}
  lead_connection: ILeadConnection
  
}

export interface ICreateLeadReference {
  reference: string
  description: string
  length: number
  connection_id: number
  maker_id: number
}

export interface ILeadConnection {
  id: number
  createdAt: string
  updatedAt: string | null
  deletedAt: string | null
  lead_type: 'STIM' | 'DEF'
  lead_connection: 'IS1' | 'IS4' | 'DF1' | 'DF4' | 'UNDER_SKIN'
}

export interface IUpdatePatientProsthesis {
  serialNumber: string
  referenceId: number
  id?: number
}

const initialState = {
  prosthesisReferencesCount: 0,
  prosthesisReferences: [],
  leadReferenceCount: 0,
  leadsReferences: [],
  transmitterReferenceCount: 0,
  transmitterReferences: [],
  leadConnexions: []
} as IState

const prosthesisReducer = produce((draft = initialState, action: AnyAction) => {
  
  switch (action.type) {
    case GET_GAMME_RANGE_SUCCESS:
      draft.gammeRange = action.payload.data
      break
    case GET_TRANSMITTER_REFERENCE_SUCCESS:
      draft.transmitterReferences = action.payload.data.data
      break
    case GET_PROSTHESIS_REFERENCES_SUCCESS:
      draft.prosthesisReferences = action.payload.data.data
      break
    case GET_PROSTHESIS_REFERENCES_SUMMARY_SUCCESS:
      draft.prosthesisReferencesCount = action.payload.data.count
      break
    case CREATE_PROSTHESIS_SUCCESS:
      draft.prosthesisReferences =
        action.payload.data
      break
    case GET_LEADS_REFERENCES_SUMMARY_SUCCESS:
      draft.leadReferenceCount = action.payload.data.count
      break
    case GET_LEADS_REFERENCES_SUCCESS:
      draft.leadsReferences = action.payload.data.data
      break
    case GET_TRANSMITTER_REFERENCE_SUMMARY_SUCCESS:
      draft.transmitterReferenceCount = action.payload.data.count
      break
    case GET_LEAD_REFERENCE_CONNEXIONS_SUCCESS:
      draft.leadConnexions = action.payload.data
      break
    case CREATE_LEAD_REFERENCE_SUCCESS:
      console.log('get create lead reference success', action.payload)
      break
    case CREATE_LEAD_REFERENCE_FAILED:
      console.log('get create lead reference failed', action.payload)
      break
    default:
      return draft
  }
})

export default prosthesisReducer
